import React from 'react'
import RouteChangeTracker from '../../../components/RouteChangeTracker'
import Navbar from '../Navbar'
import {WrapperBox} from './styles'

type Props = {
  children: React.ReactNode
}

const View = ({children}: Props) => {
  return (
    <>
      <RouteChangeTracker />
      <Navbar />
      <WrapperBox>{children}</WrapperBox>
    </>
  )
}

export default View
